<template>
  <GestionWaitingList/>
</template>
<script setup>
import GestionWaitingList from "@/views/waiting/components/GestionWaitingList.vue";
</script>
